import { useStaticQuery, graphql } from "gatsby"
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image"
import { formatWebinars } from "utils/prismic"
import get from "lodash.get"
import SEO from "components/seo"
import Info from "components/organisms/webinar/Info"
import LogoCloudAnimated from "components/organisms/LogoCloudAnimated"

const HeroImage = ({ image }) => {
  if (!image) {
    return <FallbackImage />
  }

  return (
    <GatsbyImage
      image={image}
      alt=""
      objectFit="cover"
      imgClassName="!bottom-0 lg:!bottom-[70px] !top-auto xl:!bottom-[160px]"
    />
  )
}

const FallbackImage = () => (
  <StaticImage
    src="../../images/schools/AdobeStock_576257341.jpeg"
    alt=""
    objectFit="cover"
    layout="fullWidth"
    imgClassName="!bottom-0 lg:!bottom-[70px] !top-auto xl:!bottom-[160px]"
  />
)

const Hero = ({ title, image }) => {
  return (
    <div className="relative mx-auto overflow-hidden">
      <div className=" mx-auto w-full overflow-hidden sm:h-[20em] md:h-[20em] lg:h-[24em] xl:h-[32em] ">
        <HeroImage image={image} />
      </div>
      <div className="bg-kkm-green px-4 py-6 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl text-center">
          <h1 className="m-0 p-0 text-3xl font-bold tracking-tight text-zinc-900 sm:text-4xl">
            {title}
          </h1>
        </div>
      </div>
    </div>
  )
}
export default function WebinarPage({ data, pageContext: { currentPage } }) {
  const webinars = formatWebinars(get(data, "allPrismicWebinar", []))
  const webinar = webinars?.[0]
  const heroImage = getImage(get(webinar, "heroImage"))

  return (
    <div className="">
      <SEO title={webinar?.title} />
      <Hero title={webinar?.title} image={heroImage} />
      <Info webinar={webinar} segment="professionals" />
      <LogoCloudAnimated center currentPage={currentPage} />
    </div>
  )
}

export const pageQuery = graphql`
  query ($locale: String!, $currentPage: String!) {
    allPrismicWebinar(
      sort: { data: { index: ASC } }
      filter: {
        lang: { eq: $locale }
        data: {
          audience: { eq: "general" }
          show_on_pages: { elemMatch: { page: { eq: $currentPage } } }
        }
      }
    ) {
      nodes {
        id
        lang
        data {
          hero_image {
            gatsbyImageData(layout: FULL_WIDTH)
          }
          attendance_type
          language
          show_live_link
          show_lunch_option
          audience
          time
          end
          tag {
            text
          }
          footer {
            richText
          }
          speakers {
            name
            photo {
              gatsbyImageData(width: 200, placeholder: NONE)
              alt
            }
            speaker_description {
              richText
            }
            speaker_subject {
              richText
            }
          }
          duration
          sections {
            description {
              richText
            }
          }
          title {
            text
          }
          highlights {
            text
          }
        }
      }
    }
  }
`
